import { Component, OnInit, AfterViewInit } from "@angular/core";
import { LoadingService } from "src/app/core/services/loading.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  constructor(public loading: LoadingService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.checkIOS()) {
      document.body.classList.add('ios');
    }
  }

  private checkIOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window['opera'];

    if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
        return true;
    }

    return false;
  }
}
